import React, {
  useState
} from 'react';
import { historyPropType } from '~/config/routerPropTypes';
import {
  createDoctorSchedule,
  showDoctorSchedule,
} from '~/config/routes';
import Request from '~/providers/Request';
import DoctorScheduleRecord from '~/records/DoctorScheduleRecord';
import Form from './Form';

function NewRecord({history}){
  const [record, setRecord] = useState(new DoctorScheduleRecord());
  const [loading, setLoading] = useState(false);

  async function onSubmit (saveAndContinue){
    const data = record.toParams();
    Request.post('/admin/schedules', data, {}, { controller: 'doctor_schedules' })
      .then((resp) => {
        setLoading(false);
        if(saveAndContinue){
          history.push(createDoctorSchedule.spec);
        } else {
          history.push(showDoctorSchedule.reverse(resp.data));
        }
      })
      .catch(e => {
        console.error(e);
        setLoading(false);
      });
  }

  const handleChange = (attrs) => {
    setRecord( record.updateAttributes(attrs) );
  };

  return(
    <Form
      onSubmit={onSubmit}
      record={record}
      handleChange={handleChange}
      loading={loading}
      setRecord={setRecord}
    />
  );
}

NewRecord.propTypes={
  history: historyPropType,
};

export default NewRecord;
